import { State } from "../../../vendor_core/core/src/states/State";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import CommManager from "../../../vendor_core/core/src/controllers/CommManager";
import RequestRegister from "../../../vendor_core/core/src/server/requests/RequestRegister";
import RelaxPOSTMessageController from "../../../vendor_core/server/RelaxPOSTMessageController";
import { TweenMax } from 'gsap';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import BBModel from '../model/BBModel';
import BBAnimationsHelper from '../utils/BBAnimationsHelper';
import BBUtils from '../utils/utils';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import BuyFeatureModel from '../../../vendor_core/core/src/model/BuyFeatureModel';
import ErrorModel from '../../../vendor_core/core/src/model/ErrorModel';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';

export default class BBRoundFinish extends State {
    public destroySymbolTimes = {
        background: 0.2,
        trembling: 0.02,
    };
    private teaseDelay: number = 0.2;
    public enter(): void {
        console.log("[BBRoundFinish] State enter()");
        super.enter();

        if (BuyFeatureModel.isInBuyFeatureFreeSpins) {
            BuyFeatureModel.isInBuyFeatureFreeSpins = false;
        }

        // generate random screen shake
        // let isLastCascade = SpinModel.cascadeIndex === SpinModel.cascades.length || (SpinModel.cascadeIndex === -1 && SpinModel.cascades.length === 0);

        if (!this.checkForBigWin() && !SpinModel.isInFreespins()) {
            ConsoleUtil.red("Enter check")
            let wildsOnReels = BBUtils.searchWilds(SpinModel.reelFinalSymbols).length;
            if (wildsOnReels === 2 && SpinModel.currentWin === 0 && !BBModel.hasExplode) {
                TweenMax.delayedCall(this.teaseDelay, () =>
                    this.teaseDarkenScreeShake()
                );
            } else if (
                // true
                BBModel.allowFakeScreenShakeTrigger >= 2
                // && hasTwoScatters
                // && random
                // && isLastCascade
                && !BBModel.hasExplode
            ) {
                let hasThreeWins = SpinModel.cascades.reduce((acc, cascade) => cascade.winAmount > 0 ? (acc += 1) : acc, 0) > 3 ? true : false;
                let hasWildOnReels = BBUtils.searchWilds(SpinModel.reelFinalSymbols).length >= 1 ? true : false;
                let showTease = BBUtils.randomIntFromInterval(1, 100) <= 20;
                if ((hasThreeWins || hasWildOnReels) && showTease) {
                    if (SpinModel.currentWin > 0) {
                        TweenMax.delayedCall((this.teaseDelay + 0.5), () => this.teaseDarkenScreeShake())
                    } else {
                        TweenMax.delayedCall(this.teaseDelay, () => this.teaseDarkenScreeShake())
                    }
                } else {
                    this.finishAndExit();
                }
            } else {
                this.finishAndExit();
            }
        } else {
            ConsoleUtil.red("Direct exit")
            this.finishAndExit();
        }
    }

    public canExit(): boolean {
        /**
         * Override method to alow externel skip of state
         */
        return true;
    }

    private teaseDarkenScreeShake() {
        BBAnimationsHelper.playTeaseDarkenScreeShake(this.onCompleteTease);
    }

    private finishAndExit = () => {
        BBModel.hasExplode = false;
        SpinModel.roundFinish = true;
        UIController.setState(UIStates.STOP_SPIN);
        // console.log(SpinModel);
        // console.log(BetModel);

        let payload = {
            balance: BetModel.balance,
            bet: BetModel.totalBet,
            win: {
                win: SpinModel.accumulatedWin
            },
            playResponse: {
                roundType: SpinModel.roundType
            }
        };

        RelaxPOSTMessageController.gameRoundEnded(payload);

        CommManager.send(RequestRegister.get("finishRound"),
            () => {
                this.exit()
            },
            this,
            (data) => {
                ErrorModel.update(data);
                this.exit();
            });
    }

    private onCompleteTease = () => {
        BBModel.allowFakeScreenShakeTrigger = 0;
        this.finishAndExit();
    }

    private checkForBigWin = () => {
        return this.hasSpecificBigWin() && SpinModel.cascadeIndex == SpinModel.cascades.length
    }

    private hasSpecificBigWin(): boolean {
        return this.getWinRatio() > (GameModel.gameConfig as any).bigWinRatioLevels[0];
    }

    private getWinRatio() {
        return SpinModel.currentWin / BetModel.totalBet;
    }
}
